// import axios from 'axios'
// import React, { useState, useEffect } from 'react'
// import { useParams, useNavigate } from 'react-router-dom'

// const UpdateClub = () => {

//   const { clubName, clubId } = useParams();

//   const navigate = useNavigate()

// const [treasurerMobileNo, setTreasurerMobileNo] = useState('');
// const [regionMobileNo, setRegionMobileNo] = useState('');
// const [zoneMobileNo, setZoneMobileNo] = useState('');
//   const [memberMaster, setMemberMaster] = useState([])
//   const [president, setPresident] = useState('')
//   const [presidentMobileNo, setPresidentMobileNo] = useState('');  
//   const [secretory, setSecretory] = useState('')
//   const [secretaryMobileNo, setSecretaryMobileNo] = useState('');  
//   const [treasurer, setTreasurer] = useState('')
//   const [clubSponsoredBy, setClubSponsoredBy] = useState('')
//   const [chartedOn, setChartedOn] = useState('')
//   const [extn, setExtn] = useState('')
//   const [meets, setMeets] = useState('')
//   const [place, setPlace] = useState('')
//   const [region, setRegion] = useState('')
//   const [charter, setCharter] = useState('')
//   const [zone, setZone] = useState('')
//   const [totalMembers, setTotalMembers] = useState('')
//   const [category, setCategory] = useState('')



// const updateClub = () => {
//   const dist = sessionStorage.getItem("dist");

//   axios.post(`https://lionsdirectoryapi.emedha.in/club/api/club/master/update`, {
//     category,
//     chartedOn,
//     charter,
//     clubName,
//     clubSponsoredBy,
//     extn,
//     meets,
//     place,
//     president,
//     presidentMobileNo,
//     region,
//       regionMobileNo,     
//     secretory,
//     secretaryMobileNo,
//     totalMembers,
//     treasurer,
//       treasurerMobileNo,
//     zone,
//   zoneMobileNo,       
//     clubName,
//     clubId,
//     dist
//   }).then((resp) => {
//     alert(resp.data);
//     navigate('/view-club');
//   });
// };


// const members = () => {
//   const dist = sessionStorage.getItem("dist");

//   axios.post(`https://lionsdirectoryapi.emedha.in/member-master/club`, {
//     clubName,
//     dist
//   }).then((resp) => setMemberMaster(resp.data));
// };


//   const [zc, setzc] = useState([])
//   const [rc, setrc] = useState([])

// const zChair = () => {
//   const dist = sessionStorage.getItem("dist");
//   axios.post(`https://lionsdirectoryapi.emedha.in/cabinet-zone/chair`, {
//     clubName,
//     dist
//   }).then((resp) => setzc(resp.data));
// }

// const rChair = () => {
//   const dist = sessionStorage.getItem("dist");
//   axios.post(`https://lionsdirectoryapi.emedha.in/cabinet-region/chair`, {
//     clubName,
//     dist
//   }).then((resp) => setrc(resp.data));
// }

// const clubdata = () => {
//   const dist = sessionStorage.getItem("dist");

//   axios.post('https://lionsdirectoryapi.emedha.in/club/api/club/data/get', {
//     clubName,
//     dist
//   }).then((res) => {
//     setPresident(res.data.president);
//     setCategory(res.data.category);
//     setMeets(res.data.meetsOn);
//     setChartedOn(res.data.chartedOn);
//     setZone(res.data.zoneChairperson);
//     setRegion(res.data.regionChairperson);
//     setTreasurer(res.data.treasurer);
//     setTotalMembers(res.data.totalMembers);

//     setCharter(res.data.charterPresident);
//     setExtn(res.data.extnChairperson);  // fixed typo
//     setClubSponsoredBy(res.data.clubSponsoredBy);
  
//     setPresident(res.data.president);
// setPresidentMobileNo(res.data.presidentMobile);

// setSecretory(res.data.secretory);
// setSecretaryMobileNo(res.data.secretaryMobile);

// setTreasurer(res.data.treasurer);
// setTreasurerMobileNo(res.data.treasurerMobile);

// setRegion(res.data.regionChairperson);
// setRegionMobileNo(res.data.regionChairpersonMobile);

// setZone(res.data.zoneChairperson);
// setZoneMobileNo(res.data.zoneChairpersonMobile);
//   });
// };


//   useEffect(() => {
//     members()
//     zChair()
//     rChair()
//     clubdata()
//   }, []);


//   return (
//     <div className='col-lg-6 col-md-8 col-12 mx-auto shadow-0'>
//       <input type='text' name='clubName' value={clubId} className='form-control' placeholder='Club Name'  />
//       <br />
//       <input type='text' name='clubName' value={clubName} className='form-control' placeholder='Club Name' />
//       <br />
//       <select onChange={(e) => setPresident(e.target.value)} type='text' name='secretory' className='form-control' placeholder='Scretory'   >
//         <option>Select President</option>
//         {
//           memberMaster.map((data) => {
//             if (data.secretory === null) {
//               return
//             }
//             return (
//               <option>
//                 {data.membershipName}
//               </option>
//             )

//           })
//         }
//       </select>
//       <br />
//             <br />
//       <input 
//         value={presidentMobileNo} 
//         onChange={(e) => setPresidentMobileNo(e.target.value)} 
//         type='text' 
//         name='presidentMobileNo' 
//         className='form-control' 
//         placeholder='President Mobile No' 
//       />
//       <br />
//       <select onChange={(e) => setSecretory(e.target.value)} type='text' name='secretory' className='form-control' placeholder='Scretory'   >
//         <option>Select Secretary</option>
//         {
//           memberMaster.map((data) => {
//             if (data.secretory === null) {
//               return
//             }
//             return (
//               <option>
//                 {data.membershipName}
//               </option>
//             )

//           })
//         }
//       </select>
//           <br />
//       <input 
//         value={secretaryMobileNo} 
//         onChange={(e) => setSecretaryMobileNo(e.target.value)} 
//         type='text' 
//         name='secretaryMobileNo' 
//         className='form-control' 
//         placeholder='Secretary Mobile No' 
//       />
//       <br />
//       <select onChange={(e) => setTreasurer(e.target.value)} type='text' name='secretory' className='form-control' placeholder='Scretory'   >
//         <option>Select Treasurer</option>
//         {
//           memberMaster.map((data) => {
//             if (data.secretory === null) {
//               return
//             }
//             return (
//               <option>
//                 {data.membershipName}
//               </option>
//             )

//           })
//         }
//       </select>
//       <br />
//       <input
//   value={treasurerMobileNo}
//   onChange={(e) => setTreasurerMobileNo(e.target.value)}
//   type='text'
//   className='form-control'
//   placeholder='Treasurer Mobile No'
// />
// <br />
//       <input value={clubSponsoredBy || ''} onChange={(e) => setClubSponsoredBy(e.target.value)} type='text' name='clubSponsoredBy' className='form-control' placeholder='Club Sponsored By' />
//       <br />
//       <input value={chartedOn || ''} onChange={(e) => setChartedOn(e.target.value)} type='date' name='charterOn' className='form-control' placeholder='Charted On' />
//       <br />
//       <input value={charter || ''} type='text' onChange={(e) => setCharter(e.target.value)} name='charterPresident' className='form-control' placeholder='Charter President' />
//       <br />
//       <input value={extn || ''} type='text' onChange={(e) => setExtn(e.target.value)} name='extnChairperson' className='form-control' placeholder='Extn Chairperson' />
//       <br />
//       <input value={meets || ''} type='text' name='meetOn' onChange={(e) => setMeets(e.target.value)} className='form-control' placeholder='Meets On' />
//       <br />
//       <input type='text' value={place || ''} onChange={(e) => setPlace(e.target.value)} name='place' className='form-control' placeholder='Place' />
//       <br />
//       <select type='text' onChange={(e) => setZone(e.target.value)} name='secretory' className='form-control' placeholder='Scretory'   >
//         <option>Select Zone Chairperson</option>
//         {
//           zc.map((data) => {
//             return (
//               <option>
//                 {data.membershipName}
//               </option>
//             )

//           })
//         }
//       </select>
//       <br />
//       <input
//   value={zoneMobileNo}
//   onChange={(e) => setZoneMobileNo(e.target.value)}
//   type='text'
//   className='form-control'
//   placeholder='Zone Mobile No'
// />
// <br />
//       <select onChange={(e) => setRegion(e.target.value)} type='text' name='secretory' className='form-control' placeholder='Scretory'   >
//         <option>Select Region Chairperson</option>
//         {
//           rc.map((data) => {
//             return (
//               <option>
//                 {data.membershipName}
//               </option>
//             )

//           })
//         }
//       </select>
//       <br />
//       <input
//   value={regionMobileNo}
//   onChange={(e) => setRegionMobileNo(e.target.value)}
//   type='text'
//   className='form-control'
//   placeholder='Region Mobile No'
// />
// <br />
//       <input value={totalMembers || ''} onChange={(e) => setTotalMembers(e.target.value)} type='text' name='totalMembers' className='form-control' placeholder='Total Members' />
//       <br />
//       <input type='text' value={category || ''} onChange={(e) => setCategory(e.target.value)} name='category' className='form-control' placeholder='Category' />
//       <br />
//       <button type='submit' className='btn btn-danger form-control' onClick={() => updateClub()}>Update</button>
//       <br />

//     </div>
//   )
// }

// export default UpdateClub



import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

const UpdateClub = () => {

  const { clubName, clubId } = useParams();

  const navigate = useNavigate()

const [treasurerMobileNo, setTreasurerMobileNo] = useState('');
const [regionMobileNo, setRegionMobileNo] = useState('');
const [zoneMobileNo, setZoneMobileNo] = useState('');
  const [memberMaster, setMemberMaster] = useState([])
  const [president, setPresident] = useState('')
  const [presidentMobileNo, setPresidentMobileNo] = useState('');  
  const [secretory, setSecretory] = useState('')
  const [secretaryMobileNo, setSecretaryMobileNo] = useState('');  
  const [treasurer, setTreasurer] = useState('')
  const [clubSponsoredBy, setClubSponsoredBy] = useState('')
  const [chartedOn, setChartedOn] = useState('')
  const [extn, setExtn] = useState('')
  const [meets, setMeets] = useState('')
  const [place, setPlace] = useState('')
  const [region, setRegion] = useState('')
  const [charter, setCharter] = useState('')
  const [zone, setZone] = useState('')
  const [totalMembers, setTotalMembers] = useState('')
  const [category, setCategory] = useState('')

const [clubAdministrator, setClubAdministrator] = useState('');


const [clubAdminMobileNo, setClubAdminMobileNo] = useState('');


const updateClub = () => {
  const dist = sessionStorage.getItem("dist");
  const performedBy = sessionStorage.getItem("email");

  axios.post(`https://lionsdirectoryapi.emedha.in/club/api/club/master/update`, {
    category,
    chartedOn,
    charter,
    clubName,
    clubSponsoredBy,
    extn,
    meets,
    place,
    president,
    presidentMobileNo,
    region,
      regionMobileNo,     
    secretory,
    secretaryMobileNo,
    totalMembers,
    treasurer,
      treasurerMobileNo,
      clubAdministrator,              // <-- Added field
    clubAdmin_mobileNo: clubAdminMobileNo, // <-- Added field
    zone,
  zoneMobileNo,       
    clubName,
    clubId,
    dist,
    performedBy
  }).then((resp) => {
    alert(resp.data);
    navigate('/view-club');
  });
};


const members = () => {
  const dist = sessionStorage.getItem("dist");

  axios.post(`https://lionsdirectoryapi.emedha.in/member-master/club`, {
    clubName,
    dist
  }).then((resp) => setMemberMaster(resp.data));
};


  const [zc, setzc] = useState([])
  const [rc, setrc] = useState([])

const zChair = () => {
  const dist = sessionStorage.getItem("dist");
  axios.post(`https://lionsdirectoryapi.emedha.in/cabinet-zone/chair`, {
    clubName,
    dist
  }).then((resp) => setzc(resp.data));
}

const rChair = () => {
  const dist = sessionStorage.getItem("dist");
  axios.post(`https://lionsdirectoryapi.emedha.in/cabinet-region/chair`, {
    clubName,
    dist
  }).then((resp) => setrc(resp.data));
}

const clubdata = () => {
  const dist = sessionStorage.getItem("dist");

  axios.post('https://lionsdirectoryapi.emedha.in/club/api/club/data/get', {
    clubName,
    dist
  }).then((res) => {
    setPresident(res.data.president);
    setCategory(res.data.category);
    setMeets(res.data.meetsOn);
    setChartedOn(res.data.chartedOn);
    setZone(res.data.zoneChairperson);
    setRegion(res.data.regionChairperson);
    setTreasurer(res.data.treasurer);
    setTotalMembers(res.data.totalMembers);

    setCharter(res.data.charterPresident);
    setExtn(res.data.extnChairperson);  // fixed typo
    setClubSponsoredBy(res.data.clubSponsoredBy);
  
    setPresident(res.data.president?.trim() || "");
setSecretory(res.data.secretory?.trim() || "");
setPresidentMobileNo(res.data.presidentMobile);


setSecretaryMobileNo(res.data.secretaryMobile);

setTreasurer(res.data.treasurer);
setTreasurerMobileNo(res.data.treasurerMobile);

setRegion(res.data.regionChairperson);
setRegionMobileNo(res.data.regionChairpersonMobile);

setClubAdministrator(res.data.clubAdministrator?.trim() || "");
    setClubAdminMobileNo(res.data.clubAdmin_mobileNo || "");

setZone(res.data.zoneChairperson);
setZoneMobileNo(res.data.zoneChairpersonMobile);
  });
};


  useEffect(() => {
    members()
    zChair()
    rChair()
    clubdata()
  }, []);


  return (
    <div className='col-lg-6 col-md-8 col-12 mx-auto shadow-0'>
      <input type='text' name='clubName' value={clubId} className='form-control' placeholder='Club Name'  />
      <br />
      <input type='text' name='clubName' value={clubName} className='form-control' placeholder='Club Name' />
      <br />
  <select
  value={president || ""}
  onChange={(e) => {
    const selected = memberMaster.find(
      (m) => m.membershipName === e.target.value
    );
    setPresident(selected?.membershipName || "");
    setPresidentMobileNo(selected?.mobile || "");
  }}
  className='form-control'
>
  <option value="">Select President</option>
  {memberMaster.map((data, index) => (
    <option key={index} value={data.membershipName}>
      {data.membershipName}
    </option>
  ))}
</select>
      <br />
            <br />
      <input 
        value={presidentMobileNo} 
        onChange={(e) => setPresidentMobileNo(e.target.value)} 
        type='text' 
        name='presidentMobileNo' 
        className='form-control' 
        placeholder='President Mobile No' 
      />
      <br />
      <select 
        value={secretory || ""}
      onChange={(e) => {
  const selected = memberMaster.find(
    (m) => m.membershipName === e.target.value
  );
  setSecretory(selected?.membershipName || "");
  setSecretaryMobileNo(selected?.mobile || "");
}} type='text' name='secretory' className='form-control' placeholder='Scretory'   >
        <option>Select Secretary</option>
        {
          memberMaster.map((data) => {
            if (data.secretory === null) {
              return
            }
            return (
              <option>
                {data.membershipName}
              </option>
            )

          })
        }
      </select>
          <br />
      <input 
        value={secretaryMobileNo} 
        onChange={(e) => setSecretaryMobileNo(e.target.value)} 
        type='text' 
        name='secretaryMobileNo' 
        className='form-control' 
        placeholder='Secretary Mobile No' 
      />
      <br />
      <select
      
        value={treasurer || ""}
      onChange={(e) => {
  const selected = memberMaster.find(
    (m) => m.membershipName === e.target.value
  );
  setTreasurer(selected?.membershipName || "");
  setTreasurerMobileNo(selected?.mobile || "");
}} type='text' name='secretory' className='form-control' placeholder='Scretory'   >
        <option>Select Treasurer</option>
        {
          memberMaster.map((data) => {
            if (data.secretory === null) {
              return
            }
            return (
              <option>
                {data.membershipName}
              </option>
            )

          })
        }
      </select>
      <br />
      <input
  value={treasurerMobileNo}
  onChange={(e) => setTreasurerMobileNo(e.target.value)}
  type='text'
  className='form-control'
  placeholder='Treasurer Mobile No'
/>
<br />

<select
        value={clubAdministrator || ""}
        onChange={(e) => {
          const selected = memberMaster.find(
            (m) => m.membershipName === e.target.value
          );
          setClubAdministrator(selected?.membershipName || "");
          setClubAdminMobileNo(selected?.mobile || "");
        }}
        className='form-control'
      >
        <option value="">Select Club Administrator</option>
        {memberMaster.map((data, index) => (
          <option key={index} value={data.membershipName}>
            {data.membershipName}
          </option>
        ))}
      </select>
      <br />

      <input
        value={clubAdminMobileNo}
        onChange={(e) => setClubAdminMobileNo(e.target.value)}
        type='text'
        name='clubAdminMobileNo'
        className='form-control'
        placeholder='Club Administrator Mobile No'
      />
      <br />
      <input value={clubSponsoredBy || ''} onChange={(e) => setClubSponsoredBy(e.target.value)} type='text' name='clubSponsoredBy' className='form-control' placeholder='Club Sponsored By' />
      <br />
      <input value={chartedOn || ''} onChange={(e) => setChartedOn(e.target.value)} type='date' name='charterOn' className='form-control' placeholder='Charted On' />
      <br />
      <input value={charter || ''} type='text' onChange={(e) => setCharter(e.target.value)} name='charterPresident' className='form-control' placeholder='Charter President' />
      <br />
      <input value={extn || ''} type='text' onChange={(e) => setExtn(e.target.value)} name='extnChairperson' className='form-control' placeholder='Extn Chairperson' />
      <br />
      <input value={meets || ''} type='text' name='meetOn' onChange={(e) => setMeets(e.target.value)} className='form-control' placeholder='Meets On' />
      <br />
      <input type='text' value={place || ''} onChange={(e) => setPlace(e.target.value)} name='place' className='form-control' placeholder='Place' />
      <br />
<select
  value={zone || ""}
  onChange={(e) => {
    const selected = zc.find(
      (z) => z.membershipName === e.target.value
    );
    setZone(selected?.membershipName || "");
    setZoneMobileNo(selected?.mobile || "");
  }}
   className='form-control' 
>
  <option value="">Select Zone Chairperson</option>
  {zc.map((data, index) => (
    <option key={index} value={data.membershipName}>
      {data.membershipName}
    </option>
  ))}
</select>
      <br />
      <input
  value={zoneMobileNo}
  onChange={(e) => setZoneMobileNo(e.target.value)}
  type='text'
  className='form-control'
  placeholder='Zone Mobile No'
/>
<br />
<select
  value={region || ""}
  onChange={(e) => {
    const selected = rc.find(
      (r) => r.membershipName === e.target.value
    );
    setRegion(selected?.membershipName || "");
    setRegionMobileNo(selected?.mobile || "");
  }}
  className='form-control'
>
  <option value="">Select Region Chairperson</option>
  {rc.map((data, index) => (
    <option key={index} value={data.membershipName}>
      {data.membershipName}
    </option>
  ))}
</select>
      <br />
      <input
  value={regionMobileNo}
  onChange={(e) => setRegionMobileNo(e.target.value)}
  type='text'
  className='form-control'
  placeholder='Region Mobile No'
/>
<br />
      <input value={totalMembers || ''} onChange={(e) => setTotalMembers(e.target.value)} type='text' name='totalMembers' className='form-control' placeholder='Total Members' />
      <br />
      <input type='text' value={category || ''} onChange={(e) => setCategory(e.target.value)} name='category' className='form-control' placeholder='Category' />
      <br />
      <button type='submit' className='btn btn-danger form-control' onClick={() => updateClub()}>Update</button>
      <br />

    </div>
  )
}

export default UpdateClub